import {object, date, ref, string, array, boolean, number} from "yup";
import {
    getPartialValidationEmailReceipts,
    getPartialValidationLivestreams,
    getPartialValidationLocalRecInfoApi,
    getPartialValidationMatchPointConfig,
    getPartialValidationSportEvents
} from "../forms/utils";

export default ({ intl, isLocalRecEvent = false, hasRoomTemplates, isSportEvent, showSportDataConfig, apiForm = false }) => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });
  const notADate = intl.formatMessage({ id: "app.form.notadate" });
  const notANumber = intl.formatMessage({ id: "app.form.notanumber" });
  const startDateNotAfterEndDate = intl.formatMessage({ id: "app.form.startDateNotAfterEndDate" });
  const endDateNotBeforeStartDate = intl.formatMessage({ id: "app.form.endDateNotBeforeStartDate" });

  return object().shape({
    title: string().required(requiredText),
    description: string().required(requiredText),
    roomTemplateId: hasRoomTemplates ? string().required(requiredText) : string().nullable(),
    visible: boolean().required(requiredText),
    billable: boolean().required(requiredText),
    isInternalTest: boolean().required(requiredText),
    isMutedOnStart: boolean(),
    unmuteMinutesBefore: number()
      .typeError(notANumber)
      .when("isMutedOnStart", {
        is: true,
        then: schema => schema.required(requiredText).min(0).max(20),
        otherwise: schema => schema.nullable(),
      }),
      startDate: date()
          .required(requiredText)
          .typeError(notADate)
          .when("endDate", {
              is: endDate => endDate !== null,
              then: strDate => strDate.max(ref("endDate"), startDateNotAfterEndDate),
          }),
      endDate: date()
          .required(requiredText)
          .typeError(notADate)
          .min(ref("startDate"), endDateNotBeforeStartDate),
    localRecInfo: getPartialValidationLocalRecInfoApi({isLocalRecEvent, intl}),
      ...getPartialValidationSportEvents({ intl, isSportEvent, showSportDataConfig, isLocalRecEvent, apiForm }),
      ...getPartialValidationMatchPointConfig({ intl, isSportEvent }),
    liveStreams: array().of(getPartialValidationLivestreams({ intl })),
    emailReceipts: array().of(getPartialValidationEmailReceipts({ intl })),
  });
};
